import React from 'react';
import { Col, Row } from 'react-bootstrap';

import {
  Button,
  Modal,
  Text,
  Input
} from 'v3/components';

import TextArea from 'v3/components/TextArea';

import Attachments from 'v3/pages/BlackList/Components/Attachments'

export function EditBlacklit({
  blacklist,
  show,
  onClose,
  setData,
  loading,
  data,
  updateBlacklist,
  error,
  setErrors
}) {

  function handleClose() {
    setData({})
    setErrors({});
    onClose();
  }

  return (
    <>
      <Modal
        size="lg"
        backdrop="static"
        show={show}
        closeButton={false}
        handleClose={handleClose}
        heading={
          <Col>
            <Text color="#464E5F" type="header">
              {blacklist?.active ? 'Desbloquear' : 'Bloquear'}
            </Text>
          </Col>
        }
        body={
          <Row>

            <Col md={6} xs={12}>
              <Input
                label="Motivo *"
                value={blacklist?.reason}
                onChange={event => setData(old => ({ ...old, reason: event?.target?.value }))}
                error={error?.reason}
              />
            </Col>
            <Col md={6} xs={12}>
              <TextArea
                label="Observação *"
                resizable={false}
                value={blacklist?.description}
                onChange={event => setData(old => ({ ...old, description: event?.target?.value }))}
                error={error?.description}
              />
            </Col>
            <Col>
              <Attachments setData={setData} />
            </Col>
          </Row>
        }
        footer={<>
          <>
            <Button
              onClick={() => {
                handleClose()
              }}
              loading={loading}
            >
              <Text type="regular" weight="500" color="white">
                Voltar
              </Text>
            </Button>
            <Button
              variant="success"
              style={{ marginLeft: '10px' }}
              loading={loading}
              onClick={() => {
                updateBlacklist({
                  ...data,
                  active: blacklist?.active ? 0 : 1,
                });
              }}
            >
              <Text weight={500} color="white" type="regular">
                Salvar
              </Text>
            </Button>
          </>

        </>}
      />
    </>
  );
}
